import React from "react";

const BS5_Containers = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Containers Component</h2>
      <p>This is the BS5_Containers component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Containers;
